module.exports = __webpack_public_path__ + "img/tat-center.e140e7cf.png";